import React from "react";
import Scroll from "react-scroll";
import { connect } from "react-redux";

import Button from "./Button";
import BackButton from "./BackButton";
import "../css/WizardStep.scss";

const scroll = Scroll.animateScroll;

class WizardStep extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			animate: false
		};
	}

	componentWillMount = () => {
		setTimeout(() => {
			this.setState({
				animate: true
			});
		}, 500);
	};

	componentDidMount() {
		scroll.scrollTo(0, { smooth: "easeInOut" });
	}

	sendEventData = actionType => {
		let actionValue = null;

		switch (actionType) {
			case "Industry":
				actionValue = this.props.industry;
				break;
			case "Palette":
				actionValue = this.props.palette;
				break;
			case "Goals":
				actionValue = this.props.goals;
				break;
			case "Orders":
				actionValue = this.props.orders;
				break;
			case "Rewards":
				actionValue = this.props.rewards;
				break;
			default:
				break;
		}

		// Prepare data for Segment, convert an object value to a simple comma seperated string
		// Example: "presetName: preset6,primaryColor: #f3bebf,secondaryColor: #0a4171"

		// If value is object
		if (typeof actionValue === "object" && actionValue.constructor === Object) {
			let objectToArray = [];
			for (var key in actionValue) {
				objectToArray.push(key + ": " + actionValue[key]);
			}
			actionValue = objectToArray.join(); // Convert array to string, reassign to actionValue
		}

		// If value is array
		if (Array.isArray(actionValue)) {
			if (actionType === "Rewards") {
				let rewardsArray = actionValue.map(reward => {
					return reward.rewardDescription;
				});
				actionValue = rewardsArray.join();
			} else {
				actionValue = actionValue.join(); // Convert array to string, reassign to actionValue
			}
		}

		try {
			window.redcross.track("Loyalty Generator Step Completed", {
				lpgActionType: actionType,
				lpgActionValue: actionValue
			});
		} catch (error) {}
	};

	render() {
		return (
			<div className="wizard-step-wrapper">
				<div className="wizard-step transition-container">
					<div
						className={"step-title " + (this.state.animate ? "animate" : "")}>
						{this.props.title}
					</div>
					<div
						className={
							"step-description " + (this.state.animate ? "animate" : "")
						}>
						{this.props.text}
					</div>
					<div
						className={"step-options " + (this.state.animate ? "animate" : "")}>
						{this.props.children}
					</div>
					<div
						className={
							"navigation-options " + (this.state.animate ? "animate" : "")
						}>
						<BackButton />
						<span
							onClick={() => {
								this.sendEventData(this.props.actionType);
							}}>
							<Button navigateTo={this.props.navigateTo}>
								<button disabled={this.props.disabledButton}>
									{this.props.buttonText}
								</button>
							</Button>
						</span>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		industry: state.industry,
		palette: state.palette,
		goals: state.goals,
		orders: state.orders,
		rewards: state.rewards
	};
};

export default connect(mapStateToProps)(WizardStep);
